export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9889.62af90c7.jpg";